/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

import {
  ViewDowncastWriter, ObservableMixin, toWidget, type ViewElement,
} from 'ckeditor5';

export const isImageBeingCropped = Object.create(ObservableMixin);

/**
 * Converts a given {@link module:engine/view/element~ViewElement} to an image carusel widget:
 *
 * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property}
 * allowing to recognize the image carousel widget element.
 * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
 *
 * @param {module:engine/view/element~ViewElement} viewElement
 * @param {module:engine/view/downcastwriter~ViewDowncastWriter} writer An instance of the view writer.
 * @returns {module:engine/view/element~ViewElement}
 */
export function toImageCarouselWidget(viewElement: ViewElement, writer: ViewDowncastWriter): ViewElement {
  writer.setCustomProperty('imageCarousel', true, viewElement);

  return toWidget(viewElement, writer, { label: 'Image Carousel Block', hasSelectionHandle: true });
}

/**
 *  Setting the state of cropperjs.
 * @param status Boolean value.
 */
export function setCropperStatusAndReturn(status: boolean) {
  isImageBeingCropped.set('value', status);
  return isImageBeingCropped;
}
